import "./Sidebarr.css";
import { NavLink, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/config";
// import { useGym } from "../../context/GymContext";
import { useEffect, useState } from "react";
import { getSettings } from "../../services/settingsService";
import { FaInfoCircle } from "react-icons/fa";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { FaFileInvoice } from "react-icons/fa";

import { FaBars, FaTimes } from "react-icons/fa";
import {
  FaHome,
  FaUsers,
  FaUserTie,
  FaClipboardCheck,
  FaQrcode,
  FaCreditCard,
  FaMoneyBillWave,
  FaChartBar,
  FaCog,
  FaSignOutAlt,
  FaUserFriends,
  FaAppleAlt,
  FaDumbbell,
} from "react-icons/fa";
import { MdPhone, MdLanguage } from "react-icons/md";

export default function Sidebar() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const [gym, setGym] = useState({});
  // const [gym, setGym] = useState(null);
  const [remainingDays, setRemainingDays] = useState(0);

  useEffect(() => {
    loadGym();
  }, []);

  useEffect(() => {
    if (gym) {
      console.log("Gym Data:", gym);
      console.log("Features:", gym.features);
    }
  }, [gym]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error(error);
      alert("Logout Failed");
    }
  };

  const loadGym = async () => {
    const data = await getSettings();

    if (data) {
      setGym(data);

      if (data.subscriptionEndDate) {
        const today = new Date();

        const expiry = new Date(data.subscriptionEndDate);

        const days = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

        setRemainingDays(days);
      }
    }
  };

  return (
    <>
      <button
        className="mobile-menu-btn"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>
      {menuOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}

      <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
        <div className="logo-section">
          {gym.logo && (
            <img src={gym.logo} alt="Gym Logo" className="sidebar-logo" />
          )}

          <h3>{gym.gymName || "Gym SaaS"}</h3>
        </div>
        {/* <div className="subscription-mini-card">
          <h4>{gym?.subscriptionPlan || "Trial"}</h4>

          <p>{remainingDays > 0 ? `${remainingDays} Days Left` : "Expired"}</p>
        </div> */}
        {/* <div className="gym-info-card">
          <p>
            <strong>Owner:</strong> {gym.ownerName || "-"}
          </p>

          <p>
            <strong>Phone:</strong> {gym.phone || "-"}
          </p>

          <p>
            <strong>Email:</strong> {gym.email || "-"}
          </p>
        </div> */}

        {/* <div className="gym-info-card">
          <h4>Gym Information</h4>

          <div className="info-item">
            <div className="info-icon">👤</div>

            <div className="info-content">
              <span>Owner</span>
              <h5>{gym.ownerName || "-"}</h5>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📞</div>

            <div className="info-content">
              <span>Phone</span>
              <h5>{gym.phone || "-"}</h5>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">✉️</div>

            <div className="info-content">
              <span>Email</span>
              <h5>{gym.email || "-"}</h5>
            </div>
          </div>
        </div> */}

        <nav className="menu">
          <NavLink to="/dashboard">
            <FaHome />
            <span>Dashboard</span>
          </NavLink>

          <NavLink to="/members">
            <FaUsers />
            <span>Members</span>
          </NavLink>

          <NavLink to="/AssignTrainer">
            <FaUserTie />
            <span>Assign Trainer</span>
          </NavLink>

          <NavLink to="/attendance">
            <FaClipboardCheck />
            <span>Attendance</span>
          </NavLink>

          <NavLink to="/qr-scanner">
            <FaQrcode />
            <span>QR Scanner</span>
          </NavLink>

          <NavLink to="/workout-plans">
            <FaDumbbell />
            <span>Workout Plans</span>
          </NavLink>

          <NavLink to="/diet-plans">
            <FaAppleAlt />
            <span>Diet Plans</span>
          </NavLink>

          <NavLink to="/memberships">
            <FaCreditCard />
            <span>Membership Plans</span>
          </NavLink>

          <NavLink to="/renewals">
            <FaUserFriends />
            <span>Renewals</span>
          </NavLink>

          <NavLink to="/payments">
            <FaMoneyBillWave />
            <span>Payments</span>
          </NavLink>

          <NavLink to="/trainers">
            <FaUserTie />
            <span>Trainers</span>
          </NavLink>

          <NavLink to="/reports">
            <FaChartBar />
            <span>Reports</span>
          </NavLink>

          <NavLink to="/subscription">
            <FaMoneyCheckAlt />
            <span>Subscription</span>
          </NavLink>
          <NavLink to="/invoices">
            <FaFileInvoice />
            <span>Invoices</span>
          </NavLink>
          <NavLink to="/settings">
            <FaCog />
            <span>Settings</span>
          </NavLink>
          <NavLink to="/about-software">
            <FaInfoCircle />
            <span>About Software</span>
          </NavLink>
        </nav>

        <button className="logout-btn" onClick={handleLogout}>
          <FaSignOutAlt />
          Logout
        </button>
        <div className="powered-by">
          <h4>NN FIT</h4>

          {/* <p>Powerd By NN AI Solutions</p> */}

          <a href="tel:+918688663447">
            <MdPhone className="contact-icon" />
            <span>8688663447</span>
          </a>

          <a
            href="https://www.nnaisolution.com/"
            target="_blank"
            rel="noreferrer"
          >
            <MdLanguage className="contact-icon" />
            <span>Website</span>
          </a>
        </div>
      </aside>
    </>
  );
}
